import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { Dropdown } from 'antd';
import styles from './LanguageSwitcher.module.scss';

const LanguageSwitcher = () => {
    const router = useRouter();
    const { locale, asPath } = router;

    const languages = [
        { code: 'uz', name: "O'zbek", flag: '/static/icons/uz.png' },
        { code: 'ru', name: 'Русский', flag: '/static/icons/ru.png' },
    ];

    const currentLanguage =
        languages.find((lang) => lang.code === locale) || languages[0];

    const changeLanguage = (newLocale: string) => {
        if (typeof window !== 'undefined') {
            localStorage.setItem('user_locale', newLocale);
        }

        let pathWithoutLocale = asPath.replace(/^\/(uz|ru|en)/, '');

        if (!pathWithoutLocale || pathWithoutLocale === '/') {
            pathWithoutLocale = '';
        }

        if (pathWithoutLocale && !pathWithoutLocale.startsWith('/')) {
            pathWithoutLocale = '/' + pathWithoutLocale;
        }

        const newPath = `/${newLocale}${pathWithoutLocale || '/'}`;
        router.push(newPath, undefined, {
            locale: newLocale,
            shallow: false,
        });
    };

    const menuItems = languages.map((lang) => ({
        key: lang.code,
        label: (
            <div className={styles.menuItem}>
                <Image
                    src={lang.flag}
                    alt={lang.name}
                    width={24}
                    height={18}
                    className={styles.flagIcon}
                />
                <span>{lang.name}</span>
                {locale === lang.code && (
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                    >
                        <path
                            d="M13.3333 4L6 11.3333L2.66667 8"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                )}
            </div>
        ),
        onClick: () => changeLanguage(lang.code),
        className: locale === lang.code ? styles.active : '',
    }));

    return null;

    return (
        <Dropdown
            menu={{ items: menuItems }}
            placement="bottomRight"
            trigger={['click']}
        >
            <div className={styles.languageSwitcher} role="button" tabIndex={0}>
                <Image
                    src={currentLanguage.flag}
                    alt={currentLanguage.name}
                    width={28}
                    height={21}
                    className={styles.currentFlag}
                />
            </div>
        </Dropdown>
    );
};

export default LanguageSwitcher;
